<!--
Copyright 2021 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license. See LICENSE.md in the project root for license information.
-->

<mat-sidenav-container
  class="appcontent-container"
  [hasBackdrop]="false"
  autosize
  >
  <mat-sidenav
    class="appbarmenu-container"
    #sidenav
    mode="side"
    mwlResizable
    [style.min-width.px]="leftSidebarWidth"
    [style.max-width.px]="leftSidebarWidth"
    (resizing)="resizingFn($event)"
    (resizeEnd)="resizeEndFn($event)"
    [opened]="leftSidebarOpen"
    (openedChange)="leftSidebarOpenFn($event)"
    >
    <div class="grid">
      <div class="w-100 d-flex flex-column justify-content-between align-items-center" style="height: 100%; overflow-x: hidden;">
        <mat-toolbar class="sidenav-header" title="Return to Home" [routerLink]="['/']">
          <a class="nolink" [routerLink]="['/']">
            <div class="cssLayoutRowStartCenter">
              <mat-icon class="icon-35px caster-icon-header" svgIcon="ic_crucible_caster"></mat-icon>
              <h2 class="icon-text">{{ titleText }}</h2>
            </div>
          </a>
        </mat-toolbar>
        <div class="scroll-y flex-grow-1 w-100">
          <cas-project-navigation></cas-project-navigation>
        </div>
        <mat-divider></mat-divider>

        <div class="d-flex flex-row justify-content-start align-items-end w-100" style="flex: 0 0 auto;">
          <img
            class="crucible-logo"
            alt="Crucible"
            [src]="
              (theme$ | async) === 'light-theme'
                ? 'assets/img/crucible-logo-light.png'
                : 'assets/img/crucible-logo-dark.png'
            "
            />
        </div>
      </div>
      <div
        class="resize-handle-right"
        mwlResizeHandle
        [resizeEdges]="{ right: true }"
      ></div>
    </div>
  </mat-sidenav>

  @if (project) {
    <mat-sidenav-content class="d-flex flex-column">
      <cas-topbar
        [title]="project.name"
        [topbarView]="TopbarView.CASTER_PROJECT"
        [sidenav]="sidenav"
        [projectId]="project.id"
        (sidenavToggle)="sidenav.toggle()"
        (editMemberships)="openEditMemberships()"
      ></cas-topbar>
      <cas-project
        class="project-content"
        [loading]="loading$ | async"
        [project]="project$ | async"
        [projectUI]="projectUI$ | async"
        (closeTab)="closeTab($event)"
        (tabChanged)="tabChangedFn($event)"
      >
      </cas-project>
    </mat-sidenav-content>
  }
</mat-sidenav-container>
